<div class="footer-div">
    <bos-lazy-table [data]="data"
                    [columns]="columns"
                    [minWidth]="'600px'"
                    [height]="'450px'"
                    [init]="true" (rowClick)="rowSelected($event)"
                    [routeClickPrefix]="['admin']"
                    [globalTarget]="'HtmlPage'"
    ></bos-lazy-table>

    <div class="buttons">
        <button class="left-margin login-button button-big" mat-icon-button color="primary"
                (click)="createNew()" type="submit" prevent-double-submit
                [matTooltip]="'AdminFooter.create' | translate">
            <mat-icon color="accent" class="login-icon icon-big">add_circle</mat-icon>
        </button>
    </div>
</div>
